module.exports = __webpack_public_path__ + "img/fig07.d8b4b64b.jpg";